// Vite entrypoint for the Valet.red portal.
// Mounted by app/views/layouts/portal.html.erb via vite_typescript_tag "portal".
//
// Pages live under app/javascript/pages/<Folder>/<Name>.tsx and are resolved
// by Inertia's controller render call: `render inertia: "Dashboard/Index"`.

import "@/styles/app.css"
import { createInertiaApp } from "@inertiajs/react"
import { InertiaCableProvider } from "@inertia-cable/react"
import { createRoot } from "react-dom/client"

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<{ default: React.ComponentType }>(
      "../pages/**/*.tsx",
      { eager: true }
    )
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(
        `Inertia page "${name}" not found. Looked for app/javascript/pages/${name}.tsx`
      )
    }
    return page
  },
  setup: ({ el, App, props }) => {
    // InertiaCableProvider creates a single ActionCable consumer at the
    // app root and exposes it via context. Pages opt in via useInertiaCable
    // (see pages/Agents/Index.tsx). Default URL "/cable" matches the routes
    // mount point.
    createRoot(el).render(
      <InertiaCableProvider>
        <App {...props} />
      </InertiaCableProvider>,
    )
  },
})
